interface GlobalConfig {
  supportEmail: string;
  supportPhone: string;
  practitionerSupportEmail: string;
  labsSupportEmail: string;
  freeShippingThreshold: number;
  maxDiscount: number;
  lng: string;
  marketingProtocolUrl: "https://www.fullscript.com/blog/shareable-wellness-protocols";
}

const DefaultGlobals: GlobalConfig = {
  lng: "en",
  supportEmail: "support@fullscript.com",
  supportPhone: "1 (866) 807-3828",
  practitionerSupportEmail: "practitioner-support@fullscript.com",
  labsSupportEmail: "labs@fullscript.com",
  freeShippingThreshold: 250,
  maxDiscount: 35,
  marketingProtocolUrl: "https://www.fullscript.com/blog/shareable-wellness-protocols",
};

export type { GlobalConfig };
export { DefaultGlobals };
